import { Accordion, AccordionSummary, AccordionDetails, Chip, Typography, Stack, Button, Grid, Box, Divider } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import DoneIcon from '@mui/icons-material/Done'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import Iconify from '../../../Component/common/iconify/Iconify'
import StatusLabel from '../../../Component/_v2/label/StatusChip'
import { EditCreateDisplayV2 } from '../../../Component/EditCreateDisplay/EditCreateDisplayV2'
import { getString, permissionsCheck } from '../../../helper/util'
import { constants } from '../../../Constants/constants'
import { chipRender } from '../constants'
import ReleaseNoteSection from './ReleaseNoteSection'

export default function ReleaseAccordionList({
  releaseList,
  fieldsByRelease,
  inputError,
  hideBottomBtnList,
  lang,
  theme,
  resource,
  renderField,
  onAddRelease,
  onRemoveRelease,
  onClickUpdateStatus,
  onChangeRelease,
  hideCreateButton = false,
  hideRemoveButton = false,
}) {
  const currentRole = localStorage.getItem(constants.LOCAL_STORAGE_KEY.ROLE)
  const isDeveloper = currentRole === constants.ROLE.DEVELOPER || currentRole === constants.ROLE.ROLE_SUPER_ADMIN

  return (
    <>
      <Stack direction="row" justifyContent="flex-end" sx={{ px: 2, pt: 1, my: 2 }}>
        {/* {!hideCreateButton && !permissionsCheck(constants.PERMISSION_KEY.APPVERSION_APPROVAL) && ( */}
        {!hideCreateButton && isDeveloper && (
          <Button variant="outlined" startIcon={<AddIcon />} onClick={onAddRelease}>
            {getString(lang, resource, 'create', theme)}
          </Button>
        )}
      </Stack>

      {releaseList.map((release, idx) => (
        <Accordion key={idx} defaultExpanded={idx === 0}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ width: '100%' }}>
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="subtitle1" fontWeight={600}>
                  v{release?.appVersion}{release?.buildNumber ? ` ( ${release.buildNumber} ) ` : ''}
                </Typography>
                {Object.entries(release.buildTarget || {})
                  .filter(([_, value]) => value)
                  .map(([key]) => (
                    <Chip
                      key={key}
                      size="small"
                      label={key.replace(/([A-Z])/g, ' $1').trim()}
                      variant="outlined"
                      icon={<Iconify icon={chipRender(key).icon} />}
                      color={chipRender(key).color}
                    />
                  ))}
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <StatusLabel resource={resource} keyName={release.status} />
                {inputError[idx] && Object.keys(inputError[idx]).length > 0 && (
                  <Chip size="small" color="error" label="Has Error" />
                )}
                {!release.id && !hideRemoveButton && (
                  <Button
                    size="small"
                    color="error"
                    variant="outlined"
                    onClick={(e) => { e.stopPropagation(); onRemoveRelease(idx) }}
                  >
                    {getString(lang, '', 'remove', theme)}
                  </Button>
                )}
              </Box>
            </Stack>
          </AccordionSummary>

          <AccordionDetails>

            <ReleaseNoteSection
              release={release}
              releaseIdx={idx}
              onChangeRelease={onChangeRelease}
            />

            <Divider sx={{ my: 4 }} />

            <Grid container spacing={2}>
              {fieldsByRelease[idx].map((inputSetting, fieldIdx) =>
                renderField(inputSetting, `${idx}_${fieldIdx}`)
              )}
            </Grid>

            {!hideBottomBtnList && (
              <EditCreateDisplayV2.Footer>
                {release.status === 'BETA' && permissionsCheck(constants.PERMISSION_KEY.APPVERSION_APPROVAL) && (
                  <Button variant="contained" color="secondary" startIcon={<DoneIcon />} onClick={() => onClickUpdateStatus('PILOT', release?.id)}>
                    {getString(lang, resource, 'markAsPilot', theme)}
                  </Button>
                )}
                {release.status === 'PILOT' && permissionsCheck(constants.PERMISSION_KEY.APPVERSION_APPROVAL) && (
                  <Button variant="contained" color="success" startIcon={<DoneIcon />} onClick={() => onClickUpdateStatus('STABLE', release?.id)}>
                    {getString(lang, resource, 'markAsStable', theme)}
                  </Button>
                )}
                {release.status !== 'DEPRECATED' && (
                  <Button variant="contained" color="error" startIcon={<DeleteIcon />} onClick={() => onClickUpdateStatus('DEPRECATED', release?.id)}>
                    {getString(lang, resource, 'deprecate', theme)}
                  </Button>
                )}
              </EditCreateDisplayV2.Footer>
            )}
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  )
}